// extracted by mini-css-extract-plugin
export default {"versionFooter":"VersionFooter_versionFooter__cTvpl","divider":"VersionFooter_divider__-yue2"};